import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { CanActivate, Router } from '@angular/router';
import { emailValidator, percentValidator } from '../../shared/custom-validators';
import { AuthService } from '../auth.service';
import { globalSettings } from '../../shared/config';
import { FormErrorsService } from '../../form-errors.service';
import { Subscription } from 'rxjs/Subscription';

import { cancelSubscription } from '../../shared/cancelSubscription';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    public formLogin: FormGroup;
    public loginStatus;
    public error: Boolean = false;
    public isLoading: Boolean = false;
    public previusErrorAuth: Boolean;
    private subscription1: Subscription;

    public formErrors = {
        'email': '',
        'password': ''
    };

    constructor(private fb: FormBuilder,
                private router: Router,
                private AuthService: AuthService,
                private formErrorsService: FormErrorsService ) {
        this.previusErrorAuth = this.AuthService.previusErrorAuth;
    }

    ngOnInit() {
        if (this.AuthService.isLoggedUser()) {
            this.router.navigate(['/dashboard']);
        }
        this.buildForm();
    }

    public buildForm() {
        this.formLogin = this.fb.group({
            email: ['', [
                Validators.required,
                Validators.maxLength(255),
                emailValidator,
                percentValidator
            ]],
            password: ['', [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(32)
            ]]
        });

        this.subscription1 = this.formLogin.valueChanges
            .subscribe((data) => {
                this.onValueChange();
                this.error = false;
            }
        );
        this.onValueChange();
    }

    ngOnDestroy() {
        cancelSubscription([this.subscription1]);
    }

    public onValueChange () {
        if (this.loginStatus) {this.loginStatus = ''}
        this.formErrors = this.formErrorsService.getErrors(this.formLogin, this.formErrors);
    }

    public onSubmit(form) {
        this.isLoading = true;
        const url = globalSettings.url + '/auth/login';
        this.AuthService.loginUser(url, form.value)
            .then((res) => {
                this.isLoading = false;
                if (res.status !== 200) {
                    this.loginStatus = 'Email or password is wrong';
                    this.error = true;
                }
                this.router.navigate(['/dashboard']);
            })
    }

    public sendByEnter(event, form) {
        if (event.keyCode === 13 && form.valid) {
            this.onSubmit(form);
        }
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/login/login.component.ts